import { ff_replace_all_in_str, ff_uniqid } from './utils/strings';
import { ff_ajax } from './utils/ajax';

const form_error_class = 'form__input-ctn--error';

jQuery('document').ready(() => {


  /***
   *    #### ##    ## ######## ######## ########     ###     ######  ######## #### ##     ## #### ######## ##    ##
   *     ##  ###   ##    ##    ##       ##     ##   ## ##   ##    ##    ##     ##  ##     ##  ##     ##     ##  ##
   *     ##  ####  ##    ##    ##       ##     ##  ##   ##  ##          ##     ##  ##     ##  ##     ##      ####
   *     ##  ## ## ##    ##    ######   ########  ##     ## ##          ##     ##  ##     ##  ##     ##       ##
   *     ##  ##  ####    ##    ##       ##   ##   ######### ##          ##     ##   ##   ##   ##     ##       ##
   *     ##  ##   ###    ##    ##       ##    ##  ##     ## ##    ##    ##     ##    ## ##    ##     ##       ##
   *    #### ##    ##    ##    ######## ##     ## ##     ##  ######     ##    ####    ###    ####    ##       ##
   */
  /***
  *      ####  #    # # #####  ####  #    #    ######   ##   #    # #  ####   ####  #    #
  *     #      #    # #   #   #    # #    #    #       #  #  #    # # #    # #    # ##   #
  *      ####  #    # #   #   #      ######    #####  #    # #    # # #      #    # # #  #
  *          # # ## # #   #   #      #    #    #      ###### #    # # #      #    # #  # #
  *      ####  #    # #   #    ####  #    #    #      #    #   ##   #  ####   ####  #    #.
  */
  /**
   * Détermine le favicon en fonction du "prefers-color-scheme".
   */
  // ========================================================
  // Event Listener
  // ========================================================
  setTimeout(() => {
    if (ff_favicon_url_dark) {
      const dark_mode_mq = window.matchMedia('(prefers-color-scheme: dark)');
      dark_mode_mq.addEventListener('change', ff_switch_favicon);
      ff_switch_favicon(dark_mode_mq);
    }
  }, 1);

  // ========================================================
  // Switch Favicon
  // ========================================================
  function ff_switch_favicon(e) {

    // Variables
    const is_dark_mode = e.matches;
    const favicon = document.querySelector('link[rel="shortcut icon"]');

    // Bail si pas de de balise link avec favicon
    if (!favicon) return;

    // Switch du favicon selon le mode dark/ligh
    if (is_dark_mode) favicon.href = ff_favicon_url_dark;
    else favicon.href = ff_favicon_url;
  }


  /** *
   *     ######  ####  #####  #    #    ###### #    # ###### #    # #####  ####
   *     #      #    # #    # ##  ##    #      #    # #      ##   #   #   #
   *     #####  #    # #    # # ## #    #####  #    # #####  # #  #   #    ####
   *     #      #    # #####  #    #    #      #    # #      #  # #   #        #
   *     #       ####  #    # #    #    ######   ##   ###### #    #   #    ####.
   */
  // ========================================================
  // Choisir l'onglet dans les formulaires
  // ========================================================
  jQuery('body').on('click', '.tab__headers-head', function () {
    const target = jQuery(this);
    target.closest('.tab__headers').find('.tab__headers-head').removeClass('active');
    target.addClass('active');
    target.closest('form').find('.tab').removeClass('active');
    jQuery(`.tab#${target.attr('data-tab')}`).addClass('active');
  });

  // ===============================================
  // Gestion des champs "repeater"
  // ===============================================
  jQuery('body').on('click', '.form__repeater-button', function () {

    const container = jQuery(this).closest('.form__repeater-container');
    const container_template = jQuery(`#${container.attr('data-repeater-template')}`);
    const container_fields = container.find('.form__repeater-container-fields');

    // Obtenir le dernier index
    const index = ff_uniqid();

    // Html
    let html = '';
    html += '<div class="form__repeater-container-fields-item" >';
    html += '<a class="form__repeater-container-fields-item-remove" >-</a>';
    html += '<div class="ff-cols" >';
    html += ff_replace_all_in_str(container_template.html(), '_repeater_index_', index);
    html += '</div>';
    html += '</div>';

    container_fields.append(html);
  });

  jQuery('body').on('click', '.form__repeater-container-fields-item-remove', function () {
    jQuery(this).closest('.form__repeater-container-fields-item').remove();
  });

  // ========================================================
  // Retrait des classes d'erreur sur un on change
  // ========================================================
  jQuery('body').on('change', '.form__input-ctn--error input:not([type="password"]), .form__input-ctn--error textarea, .form__input-ctn--error select', (e) => {
    setTimeout(() => {
      ff_validate_form(`#${$(e.currentTarget).closest('form').attr('id')}`, false);
    });
  });

  // ========================================================
  // Possibilité de submit un form en appuyant sur Enter
  // ========================================================
  jQuery('body').on('keydown', '.form input', (e) => {
    if (e.key === 'Enter' && $(e.currentTarget).attr('type') !== 'file') {
      ff_validate_form(`#${e.currentTarget.closest('form').getAttribute('id')}`);
      e.preventDefault();
    }
  });

});


/***
*    ########  #######  ########  ##     ##  ######
*    ##       ##     ## ##     ## ###   ### ##    ##
*    ##       ##     ## ##     ## #### #### ##
*    ######   ##     ## ########  ## ### ##  ######
*    ##       ##     ## ##   ##   ##     ##       ##
*    ##       ##     ## ##    ##  ##     ## ##    ##
*    ##        #######  ##     ## ##     ##  ######
*/
/***
*     #    #   ##   #      # #####    ##   ##### ######    ###### #    #   ##   # #
*     #    #  #  #  #      # #    #  #  #    #   #         #      ##  ##  #  #  # #
*     #    # #    # #      # #    # #    #   #   #####     #####  # ## # #    # # #
*     #    # ###### #      # #    # ######   #   #         #      #    # ###### # #
*       ##   #    # ###### # #####  #    #   #   ######    ###### #    # #    # # ######
*/
/**
 * Valide un courriel en testant chacun de ses caractères.
 *
 * @param {string} courriel Courriel à valider.
 * @returns {boolean} Valeur booléenne si oui ou non le courriel est valide.
 */
function ff_validate_email(courriel) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(courriel);
}

/***
*     #    #   ##   #      # #####    ##   ##### ######    #    # #####  #
*     #    #  #  #  #      # #    #  #  #    #   #         #    # #    # #
*     #    # #    # #      # #    # #    #   #   #####     #    # #    # #
*     #    # ###### #      # #    # ######   #   #         #    # #####  #
*       ##   #    # ###### # #####  #    #   #   ######     ####  #    # ######
*/
/**
 * Valide un URL donné.
 *
 * @param {String} url URL à valider.
 * @returns {Boolean} Valeur booléenne si oui ou non l'URL est valide.
 */
function ff_validate_url(url) {
  try {
    url = new URL(url);
  }
  catch (_) {
    const pattern = new RegExp('^(https?:\\/\\/)?' // protocol
    + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
    + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
    + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
    + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
    + '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(url);
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}

/***
*     #    #   ##   #      # #####    ##   ##### ######    #####  #    #  ####  #    # ######    #    # #    # #    # #####  ###### #####
*     #    #  #  #  #      # #    #  #  #    #   #         #    # #    # #    # ##   # #         ##   # #    # ##  ## #    # #      #    #
*     #    # #    # #      # #    # #    #   #   #####     #    # ###### #    # # #  # #####     # #  # #    # # ## # #####  #####  #    #
*     #    # ###### #      # #    # ######   #   #         #####  #    # #    # #  # # #         #  # # #    # #    # #    # #      #####
*       ##   #    # ###### # #####  #    #   #   ######    #      #    #  ####  #    # ######    #    #  ####  #    # #####  ###### #    #
*/
/**
 * Valide un numéro de téléphone en testant chacun de ses caractères.
 *
 * @param {string} telephone Numéros de telephone à valider.
 * @returns {boolean} Valeur booléenne si oui ou non le telephone est valide.
 */
function ff_validate_phone_number(telephone) {
  const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
  return re.test(telephone);
}

/***
*     #    #   ##   #      # #####    ##   ##### ######    ######  ####  #####  #    #
*     #    #  #  #  #      # #    #  #  #    #   #         #      #    # #    # ##  ##
*     #    # #    # #      # #    # #    #   #   #####     #####  #    # #    # # ## #
*     #    # ###### #      # #    # ######   #   #         #      #    # #####  #    #
*       ##   #    # ###### # #####  #    #   #   ######    #       ####  #    # #    #
*/
/**
 * Valide un formulaire en testant chacun des champs et exécute un appel AJAX selon le type du formulaire, s'il est valide.
 *
 * @param {string|HTMLElement} form_element Selecteur jQuery du formulaire ou l'élément du formulaire à valider.
 * @returns {boolean} Si oui ou non le formulaire donné est valide.
 */
window.ff_validate_form = function (form_element, send_form = true) {

  const $form = jQuery(form_element);
  if ($form.hasClass('filters-form')) {
    return false;
  }

  const $messages_ctn = $form.find('.form__messages');
  const $messages_inner = $form.find('.form__messages-inner');
  let valid_form = true;
  const $required_fields = $form.find('*[required]');
  const $email_fields = $form.find('input[type=email]');
  const $phone_fields = $form.find('input[type=tel]');
  const $url_fields = $form.find('input[type=url]');

  // Retirer les classes d'erreur
  $form.find(`.${form_error_class}`).removeClass(form_error_class);

  // ===============================================================================
  // Vérifier les champs requis
  // ===============================================================================
  $required_fields.each(function () {

    // Pour les champs "radio" ou "checkbox"
    if (jQuery(this).attr('type') == 'radio' || jQuery(this).attr('type') == 'checkbox') {
      const input_group = jQuery(this).attr('name');
      const one_input_from_group_is_checked = $(`[name="${input_group}"]`).toArray().some((input) => input.checked);
      if (!one_input_from_group_is_checked) {
        const input_group_is_already_invalid = $(`[name="${input_group}"]`).toArray().some((input) => $(input).closest('.form__input-ctn').hasClass(form_error_class));
        jQuery(this).closest('.form__input-ctn').addClass(form_error_class);
        if (!input_group_is_already_invalid) {
          valid_form = false;
          ff_handle_form_input_error(this);
        }
      }
    }
    // Pour les champ simple
    else if (jQuery(this).val() == '' || jQuery(this).val() == null) {
      jQuery(this).closest('.form__input-ctn').addClass(form_error_class);
      valid_form = false;
      ff_handle_form_input_error(this);
    }
  });

  // Vérifier les courriels
  $email_fields.each(function () {
    if (jQuery(this).val() && !ff_validate_email(jQuery(this).val())) {
      jQuery(this).closest('.form__input-ctn').addClass(form_error_class);
      valid_form = false;
      ff_handle_form_input_error(this);
    }
  });

  // Vérifier les champs de téléphone
  $phone_fields.each(function () {
    if (jQuery(this).val() && !ff_validate_phone_number(jQuery(this).val())) {
      jQuery(this).closest('.form__input-ctn').addClass(form_error_class);
      valid_form = false;
      ff_handle_form_input_error(this);
    }
  });

  // Vérifier les champs d'URL
  $url_fields.each(function () {
    if (jQuery(this).val() && !ff_validate_url(jQuery(this).val())) {
      jQuery(this).closest('.form__input-ctn').addClass(form_error_class);
      valid_form = false;
      ff_handle_form_input_error(this);
    }
  });


  // ===============================================================================
  // Gestion des messages
  // ===============================================================================
  if (!valid_form && $form.find('input:not([type="hidden"]), select, textarea').length > 1) {

    // Message d'erreur générique dans le haut du formulaire
    const message = (language == 'fr' ? 'Un ou plusieurs champs requièrent votre attention.' : 'One or multiple fields require your attention.'); // Message
    $messages_inner.empty().prepend(`<div class="ff-message error">${message}</div>`); // Ajout du message

    gsap.set($messages_ctn, { clearProps: 'display' });
    gsap.to($messages_ctn, {
      height  : 'auto',
      opacity : 1,
      duration: 0.8,
      ease    : 'Expo.easeOut',
      onStart : () => {
        if (ff_scroll && send_form) ff_scroll.scroll_to($form.get(0), { offset: -150 }); // ScrollTo vers le message
        $messages_ctn.addClass('form__messages--visible');
      },
      onComplete: () => {
        ScrollTrigger.refresh();
      }
    });

  }

  // Retrait des messages
  else if ($messages_ctn.hasClass('form__messages--visible')) {
    gsap.to($messages_ctn, {
      height    : 0,
      opacity   : 0,
      duration  : 0.8,
      ease      : 'Expo.easeOut',
      onComplete: () => {
        ScrollTrigger.refresh();
        $messages_ctn.removeClass('form__messages--visible');
        $messages_inner.empty();
      }
    });
  }


  // ===============================================================================
  // Si le formulaire doit etre envoyé en ajax
  // ===============================================================================
  if (send_form) {

    if (valid_form && $form.hasClass('ajax')) {
      valid_form = false;
      ff_send_ajax_form(form_element);
    }
    else {
      // Activer l'onglet ou la première erreur existe
      const first_tab = $form.find(`.${form_error_class}`).eq(0).closest('.tab');
      if (first_tab.length != 0) {
        const target = jQuery(`.tab__headers-head[data-tab="${first_tab.attr('id')}"]`);
        target.closest('.tab__headers').find('.tab__headers-head').removeClass('active');
        target.addClass('active');
        target.closest('form').find('.tab').removeClass('active');
        jQuery(`.tab#${target.attr('data-tab')}`).addClass('active');
      }
    }
  }

  return valid_form;
};


/***
*     #    #   ##   #    # #####  #      ######    ######  ####  #####  #    #    # #    # #####  #    # #####    ###### #####  #####   ####  #####
*     #    #  #  #  ##   # #    # #      #         #      #    # #    # ##  ##    # ##   # #    # #    #   #      #      #    # #    # #    # #    #
*     ###### #    # # #  # #    # #      #####     #####  #    # #    # # ## #    # # #  # #    # #    #   #      #####  #    # #    # #    # #    #
*     #    # ###### #  # # #    # #      #         #      #    # #####  #    #    # #  # # #####  #    #   #      #      #####  #####  #    # #####
*     #    # #    # #    # #####  ###### ######    #       ####  #    # #    #    # #    # #       ####    #      ###### #    # #    #  ####  #    #
*/
/**
 * Affiche un message d'erreur selon un champ de formulaire donné en paramètre dans l'élément '.form__messages-inner' du formulaire parent.
 *
 * @param {HTMLElement} input_element Champ dans un formulaire.
 */
window.ff_handle_form_input_error = function (input_element) {
  const parent_form_element = jQuery(input_element).closest('form').get(0);
  let $associated_label = jQuery(parent_form_element).find(`label[for="${jQuery(input_element).attr('id')}"]:not(.file-input-visual)`).eq(0);

  // Va chercher le label pour les inputs de type "radio" et "checkbox"
  if (jQuery(input_element).attr('type') == 'radio' || jQuery(input_element).attr('type') == 'checkbox') {
    $associated_label = jQuery(input_element).closest('.form__input-ctn').find('.form__label');
  }

  // Détermination du nom du champ à afficher dans le message d'erreur
  let input_name = false;
  if ($associated_label.length > 0) { // S'il y a un <label> associé au champ, on utilise son texte comme nom de champ
    input_name = $associated_label.text();
  }
  else if (jQuery(input_element).attr('placeholder')) { // Sinon, s'il y a un "placeholder", on l'utilise comme nom de champ
    input_name = jQuery(input_element).attr('placeholder');
  }

  // ===============================================================================
  // Message d'erreur pour chaque input
  // ===============================================================================
  let message = '';
  jQuery(input_element).each(function () {

    // Gestion du message ----------------------------------------------------------
    if (!jQuery(this).val() || jQuery(this).attr('type') == 'radio') { // Si le input est vide, c'est required
      message = (language == 'fr' ? 'Ce champ est requis.' : 'This field is required.');
    }
    else if (jQuery(this).attr('type') == 'email') { // Sinon si le input est un email, erreur spécifique
      message = (language == 'fr' ? 'Ce courriel est invalide.' : 'Please use a valid email.');
    }
    else if (jQuery(this).attr('type') == 'tel') { // Sinon si le input est un phone, erreur spécifique
      message = (language == 'fr' ? 'Ce numéro de téléphone est invalide.' : 'Please use a valid phone number.');
    }
    else if (jQuery(this).attr('type') == 'url') { // Sinon si le input est une URL, erreur spécifique
      message = (language == 'fr' ? 'Cette URL est invalide.' : 'Please use a valid URL.');
    }
    else if (jQuery(this).attr('type') == 'password') { // Sinon si le input est un mot de passe, erreur spécifique
      message = (language == 'fr' ? 'Ce champ requiert votre attention.' : 'This field requires your attention.');
    }
    else if (jQuery(this).attr('name') == 'recherche') { // Vérification pour la barre de recherche
      message = (language == 'fr' ? 'Entrez un minimum de trois caractères pour la recherche' : 'There\'s a mistake in this field.');
    }
    else { // Sinon c'est une erreur
      message = (language == 'fr' ? 'Il y a une erreur dans ce champ.' : 'There\'s a mistake in this field.');
    }

    // Ajout du message dans le html ----------------------------------------------
    if (jQuery(this).attr('type') == 'radio') { // Si le input est radio
      jQuery(this).closest('.form__input-ctn').find('.form__input-message').text(message);
    }
    else {
      jQuery(this).closest('.form__input-ctn').find('.form__input-message').text(message);
    }
  });

};

/***
*     #    #   ##   #   # #####  ######         #####  ######  ####    ##   #####  #####  ####  #    #   ##
*     ##  ##  #  #   # #  #    # #              #    # #      #    #  #  #  #    #   #   #    # #    #  #  #
*     # ## # #    #   #   #####  #####          #    # #####  #      #    # #    #   #   #      ###### #    #
*     #    # ######   #   #    # #              #####  #      #      ###### #####    #   #      #    # ######
*     #    # #    #   #   #####  ######         #    # ######  ####  #    # #        #    ####  #    # #    #
*/
/**
 * Si la variable grecaptcha n'est pas définie, on ne fait pas de requête à Google pour obtenir un token.
 *
 * @returns {Promise} Promise.
 */
function ff_maybe_recaptcha() {
  return new Promise((resolve) => {
    if (typeof grecaptcha === 'undefined') {
      resolve('grecaptcha-undefined');
    }
    else {
      grecaptcha.ready(() => {
        grecaptcha.execute(google_recaptcha_v3_client_key, { action: 'submit' }).then((token) => {
          resolve(token);
        });
      });
    }
  });
}

/***
*      ####  ###### #    # #####       ##        #   ##   #    #    ######  ####  #####  #    #
*     #      #      ##   # #    #     #  #       #  #  #   #  #     #      #    # #    # ##  ##
*      ####  #####  # #  # #    #    #    #      # #    #   ##      #####  #    # #    # # ## #
*          # #      #  # # #    #    ######      # ######   ##      #      #    # #####  #    #
*      ####  ###### #    # #####     #    #  ####  #    # #    #    #       ####  #    # #    #
*/
/**
 * Envoie un formulaire en AJAX et affiche un message de confirmation ou d'erreur selon la réponse.
 *
 * @param {HTMLElement|string} p_form Élément ou sélecteur jQuery du formulaire à envoyer.
 * @param {Function} on_success_callback Fonction à appeler lors du succès de l'appel AJAX.
 * @returns {Promise} Promise resolu lorsque l'appel AJAX est complété.
 */
window.ff_send_ajax_form = function (p_form, on_success_callback = null) {
  return new Promise((resolve) => {

    const $form = jQuery(p_form);
    const $messages_ctn = $form.find('.form__messages');
    const $messages_inner = $form.find('.form__messages-inner');
    const animate_message_ctn = () => {
      if (typeof gsap === 'undefined') return;
      gsap.to($messages_ctn, {
        height  : 'auto',
        opacity : 1,
        duration: 0.8,
        delay   : $form.hasClass('hide-on-success') ? 0.6 : 0,
        ease    : 'Power3.easeOut',
        onStart : () => {
          if (!$form.hasClass('hide-on-success--keep-height') && ff_scroll) {
            ff_scroll.scroll_to($form.get(0), { offset: -150 }); // ScrollTo vers le message
          }
        },
        onComplete: () => {
          ScrollTrigger.refresh();
          $messages_ctn.addClass('form__messages--visible');
        }
      });
    };

    $form.addClass('form--loading');
    $messages_inner.empty();

    // Google reCaptcha v3
    ff_maybe_recaptcha().then((token) => {

      // Ajouter la réponse recaptcha au formulaire
      $form.find('input[name="g-recaptcha-response"]').remove(); // Just in case
      $form.append(`<input name="g-recaptcha-response" value="${token}" type="hidden" >`);

      const $password_fields = $form.find('input[type=password]');
      const form_data = new FormData($form[0]); // On prend le contenu du formulaire et le le met dans "form_data"

      // AJAX!
      ff_ajax({
        dataType: 'json',
        data    : form_data,
        complete: function () {
          $form.removeClass('form--loading');
          $form.find('input[name="g-recaptcha-response"]').remove(); // On retire le champ recaptcha su formulaire
          resolve();
        },
        error: function (request, status, error) {

          // Erreurs dans la console
          console.error('AJAX ERROR');
          if (error) {
            console.error('Error:', error);
          }
          console.error('Request status code:', request.status, `https://developer.mozilla.org/fr/docs/Web/HTTP/Status/${request.status}`);
          console.error('Request response:', request.responseText);

          // Affichage d'un message d'erreur
          $messages_ctn.css('display', 'block');
          $messages_inner.append(`<div class="ff-message error">${__('Une erreur s\'est produite. Veuillez essayer ultérieurement.', 'fatfish')}</div>`);
          animate_message_ctn();

        },
        success: function (json) {

          // Appel du callback donné en argument
          if (on_success_callback) {
            on_success_callback(json);
          }

          // Repositionner les messages dans .form__messages-inner
          if (json.data.html) {

            const obj_html = jQuery('<div></div>').html(json.data.html);
            const results = obj_html.find('.ff-message');
            if (results.length != 0) {
              results.each(function () {
                $form.find('.form__messages-inner').append(jQuery(this)[0].outerHTML);
              });
              results.remove();
            }
          }

          // Animation du conteneur de messages
          if (!$form.hasClass('filters-form')) {
            animate_message_ctn();
          }

          // Success!
          if (json.success) {

            // Rediriger on success
            if ($form.attr('data-redirect') != '') {
              window.location.href = $form.attr('data-redirect');
            }
            // Soumettre le formulaire on success
            else if ($form.hasClass('submit-on-success')) {
              $form.removeAttr('onsubmit'); // Afin d'éviter la boucle infinie de validation
              $form.trigger('submit');
            }
            // Sinon, on vide les champs non hidden
            else if ($form.hasClass('empty-fields-on-success')) {
              $form.find("*[name][type!='hidden']").each(function () {
                jQuery(this).val('');
              });
              $form.find('select option').removeAttr('selected');
              $form.find('select option:first-child').attr('selected', true);
              if (typeof $form.find('select.selectric').selectric === 'function') {
                $form.find('select.selectric').selectric('refresh');
              }
              $form.find("*[type='checkbox']").removeAttr('checked');
              $form.find("*[type='radio']").removeAttr('checked');
              $form.find("*[type='radio']:first-child").attr('checked', true);
              $form.find("*[type='file']").trigger('change');
            }
          }

          // Si le form est invalide
          else {

            if (json.data.error) {
              console.error(json.data.error);
            }

            if (json.data.password_error) {
              $password_fields.each(function () {
                jQuery(this).closest('.form__input-ctn').addClass(form_error_class);
                ff_handle_form_input_error(this);
              });
            }

          }

        }
      });

    });


  });
};
